export var SITE_FILTER_TYPE_NAME = 'sites';
export var DEFAULT_OPTION = 'default';
export var FilterUIVariant = /*#__PURE__*/function (FilterUIVariant) {
  FilterUIVariant["CHECKBOX"] = "CHECKBOX";
  FilterUIVariant["STATIC_SELECT"] = "STATIC_SELECT";
  FilterUIVariant["MULTI_SELECT"] = "MULTI_SELECT";
  return FilterUIVariant;
}({});
export var LastModifiedValues = /*#__PURE__*/function (LastModifiedValues) {
  LastModifiedValues["DEFAULT"] = "default";
  LastModifiedValues["TODAY"] = "today";
  LastModifiedValues["YESTERDAY"] = "yesterday";
  LastModifiedValues["PAST_SEVEN_DAYS"] = "past7Days";
  LastModifiedValues["PAST_THIRTY_DAYS"] = "past30Days";
  LastModifiedValues["PAST_YEAR"] = "pastYear";
  return LastModifiedValues;
}({});